var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNhHeart = function SvgNhHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_216_42",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0H0.5V20H20.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_216_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.95296 3.74783C2.54244 4.15835 2.21679 4.64571 1.99461 5.18209C1.77243 5.71847 1.65808 6.29335 1.65808 6.87392C1.65808 7.45449 1.77243 8.02938 1.99461 8.56576C2.21679 9.10214 2.54244 9.5895 2.95296 10L10.5 17.5471L18.047 10C18.8761 9.17093 19.3419 8.04644 19.3419 6.87392C19.3419 5.70141 18.8761 4.57692 18.047 3.74783C17.218 2.91873 16.0935 2.45295 14.9209 2.45295C13.7484 2.45295 12.6239 2.91873 11.7949 3.74783L10.5 5.04267L9.20516 3.74783C8.79464 3.3373 8.30727 3.01165 7.7709 2.78947C7.23452 2.56729 6.65963 2.45294 6.07906 2.45294C5.49849 2.45294 4.92361 2.56729 4.38723 2.78947C3.85085 3.01165 3.36349 3.3373 2.95296 3.74783Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgNhHeart;